function truncate_errors(hasMessages) {
    const $ = jQuery.noConflict();

    const truncate = () => {
        $.post('/errors/truncate', {}, function() {
            squde_reload_for_flashes();
            reload_location_if_needed();
        });
    }
    if (!hasMessages) {
        truncate();
    } else {
        confirm('Weet u zeker dat u alle foutmeldingen wilt verwijderen?<br />Er zijn nog niet verzonden berichten die dan ook verwijderd worden.', truncate);
    }
}
